module.exports = __webpack_public_path__ + "static/media/profile_pic.493e1e17.png";


//////////////////
// WEBPACK FOOTER
// ./src/Static/profile_pic.png
// module id = 24
// module chunks = 1